import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {PlanningParameterCollection} from './planning-parameter-collection';
import * as classTransformer from 'class-transformer';
import {PlanningParameter} from './planning-parameter';
import {Manufacturer} from '../manufacturer/manufacturer';
import {ManufacturerService} from '../manufacturer/manufacturer.service';

@Injectable({
  providedIn: 'root',
})
export class PlanningParameterService {
    constructor(
        private httpClient: HttpClient,
    ) {
    }

    static buildIri(planningParameter: PlanningParameter): string {
        return `/cpe/manufacturers/${planningParameter.manufacturer.id}/planning-parameters/${planningParameter.id}`;
    }

    public getAll(manufacturer: Manufacturer): Observable<PlanningParameterCollection> {
        return this.httpClient
            .get('/manufacturers/' + manufacturer.id + '/planning-parameters')
            .pipe(map((result: any) => {
                const collection = new PlanningParameterCollection();
                collection.setTotalItems(result['totalItems']);
                collection.setPlanningParameters(
                    result['member'].map((parameterData: any) => classTransformer.plainToInstance(PlanningParameter, parameterData))
                );

                return collection;
            }));
    }

    public create(name: string, manufacturer: Manufacturer): Observable<PlanningParameter> {
        const params = {
            name,
            manufacturer: ManufacturerService.buildIri(manufacturer),
        };

        return this.httpClient
            .post('/manufacturers/' + manufacturer.id + '/planning-parameters', params)
            .pipe(map((parameterData: any) => classTransformer.plainToInstance(PlanningParameter, parameterData)))
    }
}
